import React from "react";


export const person = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-7"
        transform="translate(2.000000, 0.000000)"
        stroke="#FFFFFF"
        strokeWidth="2.27272727"
      >
        <rect
          id="Rectangle"
          stroke="var(--black)"
          x="5.13636364"
          y="1.13636364"
          width="8.72727273"
          height="8.72727273"
          rx="4.36363636"
        ></rect>
        <path
          stroke="var(--black)"
          d="M0,22 C0.89230698,16.8753285 5.03694781,13 10.0145938,13 C14.9403507,13 19.0497811,16.7943199 20,21.8384861"
          id="Stroke-1"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </g>
  </svg>
);

export const key = (
  <svg
    width="37px"
    height="21px"
    viewBox="0 0 37 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="noun_Key_3228328"
        transform="translate(18.500000, 10.500000) rotate(90.000000) translate(-18.500000, -10.500000) translate(8.000000, -7.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
        stroke="var(--black)"
        strokeWidth="0.7"
      >
        <path
          d="M12.2146307,1.05429265 C11.703611,0.54285386 11.0216926,0.261374081 10.2941176,0.261374081 C9.56654271,0.261374081 8.88462433,0.54285386 8.3736046,1.05429265 L1.20592286,8.22197396 C0.694484069,8.73299369 0.413004289,9.41491207 0.413004289,10.142487 C0.413004289,10.8700619 0.694484069,11.5519803 1.20592286,12.0630001 L7.43533866,18.2928345 L7.43533866,31.0863416 C7.43533866,31.186451 7.47052353,31.2836288 7.53461042,31.3607004 L10.3573669,34.7556314 C10.4327631,34.8461072 10.5420879,34.9018164 10.65979,34.909356 C10.669005,34.9097751 10.6782203,34.9101937 10.6870167,34.9101937 C10.7955038,34.9101937 10.9002207,34.8691446 10.9798058,34.7950047 L14.7324505,31.2924243 C14.8199942,31.2107447 14.8694206,31.0959748 14.8685829,30.9761782 C14.8677452,30.8568008 14.8174808,30.7428685 14.7290998,30.6620267 L13.4339578,29.4795602 L14.7290998,28.2966748 C14.8178998,28.2154143 14.8685829,28.1006443 14.8685829,27.9800101 C14.8685829,27.8593759 14.8178998,27.7446059 14.7290998,27.6633455 L13.487573,26.5294677 L14.7290998,25.3951713 C14.8178998,25.3139108 14.8685829,25.1991409 14.8685829,25.0785067 C14.8685829,24.9578725 14.8178998,24.8431025 14.7290998,24.761842 L13.4339578,23.5789566 L14.7290998,22.3964901 C14.8178998,22.3152297 14.8685829,22.2004597 14.8685829,22.0798255 C14.8685829,21.9591913 14.8178998,21.8444213 14.7290998,21.7631608 L13.324633,20.4801659 L13.324633,18.1206795 L19.3823124,12.0630001 C19.8937512,11.5519803 20.175231,10.8700619 20.175231,10.142487 C20.175231,9.41491207 19.8937512,8.73299369 19.3823124,8.22197396 L12.2146307,1.05429265 Z M18.7757903,11.4564784 L12.5924501,17.6398186 C12.5120273,17.7202414 12.4667894,17.8291471 12.4667894,17.9430794 L12.4667894,20.6694958 C12.4667894,20.79013 12.5174725,20.9048999 12.6062725,20.9861604 L13.8038181,22.0798268 L12.5086762,23.2622932 C12.4198761,23.3435537 12.369193,23.4583237 12.369193,23.5789578 C12.369193,23.699592 12.4198761,23.814362 12.5086762,23.8956225 L13.8038181,25.078508 L12.5622914,26.2128544 C12.4734913,26.2940648 12.4228082,26.4088348 12.4228082,26.529469 C12.4228082,26.6501032 12.4734913,26.7648732 12.5622914,26.8461336 L13.8038181,27.9800114 L12.5086762,29.1628969 C12.4198761,29.2441574 12.369193,29.3589273 12.369193,29.4795615 C12.369193,29.6001957 12.4198761,29.7149657 12.5086762,29.7962262 L13.8071693,30.9820433 L10.72639,33.8575773 L8.29318137,30.9313602 L8.29318137,18.1152344 C8.29318137,18.0013021 8.24794344,17.8923963 8.16752065,17.8119735 L1.81244498,11.4564784 C1.46310852,11.1071419 1.27084786,10.640522 1.27084786,10.142487 C1.27084786,9.64445202 1.46310852,9.17783254 1.81244498,8.82849565 L8.98012629,1.66081434 C9.32946317,1.31147788 9.79608266,1.11921722 10.2941176,1.11921722 C10.7921526,1.11921722 11.2587721,1.31147788 11.608109,1.66081434 L18.7757907,8.82849608 C19.1251272,9.17783254 19.3173879,9.64445245 19.3173879,10.1424874 C19.3173879,10.6405224 19.1251268,11.1071419 18.7757903,11.4564784 Z"
          id="Shape"
        ></path>
        <path
          d="M13.6861165,7.70090159 L6.90211881,7.70090159 C5.92573591,7.70090159 5.1315606,8.4950769 5.1315606,9.4714598 C5.1315606,10.4478427 5.92573591,11.242018 6.90211881,11.242018 L13.6861165,11.242018 C14.6624994,11.242018 15.4566747,10.4478427 15.4566747,9.4714598 C15.4566747,8.4950769 14.6624994,7.70090159 13.6861165,7.70090159 Z M13.6861165,10.3841744 L6.90211881,10.3841744 C6.39863866,10.3841744 5.98940374,9.97493952 5.98940374,9.47145937 C5.98940374,8.96797923 6.39863866,8.5587443 6.90211881,8.5587443 L13.6861165,8.5587443 C14.1895966,8.5587443 14.5988316,8.96797923 14.5988316,9.47145937 C14.5988316,9.97493952 14.1895966,10.3841744 13.6861165,10.3841744 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const wallet = (
  <svg width="31" height="25" xmlns="http://www.w3.org/2000/svg">
    <g fill="#000" fillRule="nonzero" stroke="#000" strokeWidth=".7">
      <path d="M23.3 11.8a2.2 2.2 0 100 4.3 2.2 2.2 0 000-4.3zm0 3.2a1 1 0 110-2 1 1 0 010 2z" />
      <path d="M28.8 9.1V2.9c0-1-.8-1.9-1.9-1.9H3C1.9 1 1 1.8 1 2.9h0V22.2c0 1 .8 1.9 1.9 1.9h24c1 0 2-.9 2-1.9v-3.5c.9-.1 1.6-1 1.6-2V11c0-1-.7-1.7-1.7-1.8zm-26-7H27c.4 0 .8.4.8.8v1l-.8-.2H3a.8.8 0 01-.8-.5v-.3c0-.4.4-.8.8-.8zm25 20.1c0 .4-.4.7-.9.7H3a.7.7 0 01-.8-.7V4.7l.8.1h24c.4 0 .8.4.8.8h0v3.5h-4.5a4.8 4.8 0 00-4.8 4.8c0 2.6 2.1 4.8 4.8 4.8h4.5v3.5zm1.6-5.4c0 .4-.3.8-.8.8h-5.4a3.7 3.7 0 01-3.7-3.7 3.7 3.7 0 013.7-3.7h5.4c.5 0 .8.3.8.7v5.9z" />
    </g>
  </svg>
);

export const subscription = (
    <svg width="29px" height="28px" viewBox="0 0 29 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>noun-subscription-456178</title>
      <g id="SPIN-connect---DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="SPIN-connect---PAGE-8B---NAV-BAR---MENU---SETTINGS" transform="translate(-1042.000000, -534.000000)" fill="#000000" fill-rule="nonzero">
          <g id="Group-26" transform="translate(1012.000000, 69.000000)">
            <g id="noun-subscription-456178" transform="translate(30.000000, 465.000000)">
              <path d="M13.1465261,1.75525813 L25.0789931,1.75525813 C25.8075525,1.75525813 26.4318019,2.34031344 26.4318019,3.09751434 L26.4318019,14.9369025 C26.4318019,15.6597787 25.842147,16.2791587 25.0789931,16.2791587 L25.0789931,18 C26.7787379,18 28.1661721,16.6234499 28.1661721,14.9369025 L28.1661721,3.06309751 C28.1661721,1.37661158 26.7787998,0 25.0789931,0 L13.1465261,0 C11.4467814,0 10.0593472,1.37655012 10.0593472,3.06309751 L11.7937174,3.06309751 C11.7937174,2.34046709 12.3833723,1.7554425 13.1465261,1.7554425 L13.1465261,1.75525813 Z" id="Path"></path>
              <path d="M8.11685255,6.72413793 L20.0493196,6.72413793 C20.7778789,6.72413793 21.4021283,7.31031404 21.4021283,8.06896552 L21.4021283,19.9310345 C21.4021283,20.6552956 20.8124734,21.2758621 20.0493196,21.2758621 L20.0493196,23 C21.7490643,23 23.1364985,21.6208128 23.1364985,19.9310345 L23.1364985,8.06896552 C23.1364985,6.37924877 21.7491262,5 20.0493196,5 L8.11685255,5 C6.41710781,5 5.02967359,6.37918719 5.02967359,8.06896552 L6.76404379,8.06896552 C6.76404379,7.34495074 7.35369869,6.72413793 8.11685255,6.72413793 L8.11685255,6.72413793 Z" id="Path"></path>
              <path d="M3.08717896,28 L15.019646,28 C16.7193907,28 18.1068249,26.6208128 18.1068249,24.9310345 L18.1068249,13.0689655 C18.1068249,11.3792488 16.7194526,10 15.019646,10 L3.08717896,10 C1.38743422,10 0,11.3791872 0,13.0689655 L0,24.9310345 C0,26.6205665 1.38762005,28 3.08717896,28 L3.08717896,28 Z M1.7343702,13.0689655 C1.7343702,12.3447044 2.3240251,11.7241379 3.08717896,11.7241379 L15.019646,11.7241379 C15.7482053,11.7241379 16.3724547,12.310314 16.3724547,13.0689655 L16.3724547,24.9310345 C16.3724547,25.6552956 15.7827998,26.2758621 15.019646,26.2758621 L3.08717896,26.2758621 C2.35861959,26.2758621 1.7343702,25.689686 1.7343702,24.9310345 L1.7343702,13.0689655 Z" id="Shape"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
);

export const location = (
  <svg width="19" height="26" xmlns="http://www.w3.org/2000/svg">
    <g fill="#000" fillRule="nonzero" stroke="#000">
      <path d="M9.69922 1.05822c-4.66974 0-8.4668 3.79706-8.4668 8.4668 0 3.39549 2.05628 7.01511 4.06836 9.83203 2.01209 2.81692 4.0254 4.83008 4.0254 4.83008.20662.20642.54141.20642.74804 0 0 0 2.0133-2.01316 4.02539-4.83008 2.01208-2.81692 4.0664-6.43654 4.0664-9.83203 0-4.66974-3.79705-8.4668-8.4668-8.4668h0zm0 1.0586c4.09778 0 7.4082 3.31042 7.4082 7.4082 0 2.95452-1.91247 6.47747-3.86914 9.2168-1.76976 2.47767-3.21727 3.91965-3.53906 4.24804-.32238-.329-1.76775-1.77093-3.53711-4.24804-1.95667-2.73933-3.8711-6.26228-3.8711-9.2168 0-4.09778 3.31043-7.4082 7.4082-7.4082z" />
      <path d="M9.69922 5.81994c-2.03949 0-3.70313 1.66559-3.70313 3.70508 0 2.03949 1.66364 3.70508 3.70313 3.70508s3.70508-1.66559 3.70508-3.70508c0-2.03949-1.6656-3.70508-3.70508-3.70508zm0 1.0586c1.46752 0 2.64648 1.17896 2.64648 2.64648s-1.17896 2.64648-2.64648 2.64648-2.64453-1.17896-2.64453-2.64648 1.177-2.64648 2.64453-2.64648z" />
    </g>
  </svg>
);

export const checkCircle = (
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-15"
        transform="translate(1.000000, 1.000000)"
        stroke="var(--black)"
      >
        <circle id="Oval" strokeWidth="2" cx="10" cy="10" r="10"></circle>
        <path
          d="M12.8674692,8.22804647 C12.6777213,8.05193178 12.3811311,8.06298369 12.2049568,8.2527958 L9.14968607,11.5436528 L8.69166747,11.0499191 L7.79498364,10.0833142 C7.78294758,10.0706651 7.78294758,10.0706651 7.77029851,10.0586291 C7.5805506,9.8825144 7.28396036,9.8935663 7.10784567,10.0833142 L6.90105186,10.3061161 C6.73414384,10.4859447 6.73414384,10.7640553 6.90105186,10.9438839 L8.79075233,12.9805051 L8.83158769,13.0219535 C8.92435399,13.1080547 9.0439213,13.1514303 9.13391914,13.1490064 L9.21950885,13.1420629 C9.32440855,13.1266017 9.42008434,13.0769496 9.49404053,12.9972684 L13.0989481,9.11330124 C13.2658562,8.9334727 13.2658562,8.65536206 13.0989481,8.47553352 L12.8921543,8.2527316 C12.8801183,8.24008252 12.8801183,8.24008252 12.8674692,8.22804647 Z"
          id="checked-2"
          strokeWidth="1.25"
          fill="#000000"
        ></path>
      </g>
    </g>
  </svg>
);

export const backArrow = (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14">
    <path
      fill="var(--black)"
      fillRule="evenodd"
      d="M7.7.3a1 1 0 010 1.4L2.3 7l5.4 5.3c.4.3.4 1 0 1.4a1 1 0 01-1.4 0L.3 8A1 1 0 010 7c0-.3 0-.6.3-.9l6-5.8a1 1 0 011.4 0z"
    />
  </svg>
);

export const cog = (
  <svg
    width="84px"
    height="84px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-21">
        <circle id="Oval" fill="#212126" cx="12.6" cy="12.6" r="12.6"></circle>
        <g
          id="noun_Settings_2187506"
          transform="translate(6.000000, 6.600000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <path
            d="M13.4205846,5.80953889 L10.3661478,0.311552559 C10.2581587,0.119436479 10.055062,0.000379784975 9.83467578,0 L3.72580207,0 C3.50541585,0.000379784975 3.30231914,0.119436479 3.19433006,0.311552559 L0.139893208,5.80953889 C0.0307686894,5.9985481 0.0307686894,6.23141705 0.139893208,6.42042626 L3.19433006,11.9184126 C3.30543375,12.1058257 3.50794166,12.2198819 3.72580207,12.2177769 L9.83467578,12.2177769 C10.055062,12.2173676 10.2581587,12.0983109 10.3661478,11.9061949 L13.4205846,6.40820852 C13.5250688,6.22232848 13.5250688,5.99541893 13.4205846,5.80953889 Z M9.47425223,10.9959727 L4.08622562,10.9959727 L1.36777682,6.1088737 L4.08622562,1.22177474 L9.47425223,1.22177474 L12.192701,6.1088737 L9.47425223,10.9959727 Z"
            id="Shape"
          ></path>
          <path
            d="M6.78023892,3.66532422 C5.43070381,3.66532422 4.33668944,4.75933859 4.33668944,6.1088737 C4.33668944,7.45840882 5.43070381,8.55242319 6.78023892,8.55242319 C8.12977404,8.55242319 9.22378841,7.45840882 9.22378841,6.1088737 C9.22378841,5.46080409 8.96634375,4.83927772 8.50808933,4.3810233 C8.04983491,3.92276888 7.42830854,3.66532422 6.78023892,3.66532422 Z M6.78023892,7.33064845 C6.10547137,7.33064845 5.55846418,6.78364126 5.55846418,6.1088737 C5.55846418,5.43410615 6.10547137,4.88709896 6.78023892,4.88709896 C7.45500648,4.88709896 8.00201367,5.43410615 8.00201367,6.1088737 C8.00201367,6.78364126 7.45500648,7.33064845 6.78023892,7.33064845 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const walletBigBlack = (
  <svg
    width="84px"
    height="84px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <circle id="Oval" fill="#212126" cx="12.6" cy="12.6" r="12.6"></circle>
      <g
        id="noun_Wallet_1884380"
        transform="translate(6.8, 7.5) scale(0.42)"
        fill="#FFFFFF"
        fillRule="nonzero"
        stroke="var(--white)"
        strokeWidth="0.7"
      >
        <path
          d="M22.3361047,10.8078063 C21.1441906,10.8078063 20.1745718,11.7774819 20.1745718,12.9693392 C20.1745718,14.1612533 21.1442473,15.1309289 22.3361047,15.1309289 C23.5280188,15.1309289 24.4976943,14.1612533 24.4976943,12.9693392 C24.4976943,11.7774819 23.5280188,10.8078063 22.3361047,10.8078063 Z M22.3361047,13.9956104 C21.7702619,13.9956104 21.3098903,13.5352387 21.3098903,12.9693392 C21.3098903,12.4034965 21.7702619,11.9431248 22.3361047,11.9431248 C22.9020042,11.9431248 23.3623758,12.4034965 23.3623758,12.9693392 C23.3623758,13.5352387 22.9020042,13.9956104 22.3361047,13.9956104 Z"
          id="Shape"
        ></path>
        <path
          d="M27.8185608,8.09986888 L27.8185608,1.89369394 C27.8185608,0.849493577 26.9661199,0 25.9183384,0 L1.89060824,0 C0.865667389,0 0.031843578,0.849493577 0.031843578,1.89369394 L0.031843578,1.93986267 L0,1.93986267 C0,2.058416 0.0112814072,2.17397639 0.031843578,2.28604502 L0.031843578,21.1976 C0.031843578,22.2400822 0.848272904,23.0566535 1.89060824,23.0566535 L25.9183384,23.0566535 C26.9661199,23.0566535 27.8185608,22.2226788 27.8185608,21.1976 L27.8185608,17.6719827 C28.7833156,17.5820285 29.5413373,16.7610786 29.5413373,15.764488 L29.5413373,9.94002261 C29.5413373,8.96161131 28.7977092,8.18372637 27.8185608,8.09986888 Z M1.89060824,1.10849296 L25.9183384,1.10849296 C26.3458648,1.10849296 26.7070921,1.46808807 26.7070921,1.89369394 L26.7070921,2.88607226 C26.4668482,2.7768857 26.1998178,2.71580774 25.9183384,2.71580774 L1.89060824,2.71580774 C1.53705005,2.71580774 1.23823169,2.49034028 1.14331227,2.16339028 L1.14331227,1.89369394 C1.14331227,1.45340054 1.47158454,1.10849296 1.89060824,1.10849296 Z M26.7070921,21.1976 C26.7070921,21.6184947 26.3606473,21.9481605 25.9183384,21.9481605 L1.89060824,21.9481605 C1.46458229,21.9481605 1.14331227,21.6254782 1.14331227,21.1976 L1.14331227,3.67254801 C1.37266383,3.77020624 1.62524509,3.8243007 1.89060824,3.8243007 L25.9183384,3.8243007 C26.347921,3.8243007 26.6974779,4.15684859 26.6974779,4.60024577 L26.7070921,4.60024577 L26.7070921,8.09199858 L22.1640194,8.09199858 C19.5114438,8.09199858 17.3533607,10.2426966 17.3533607,12.8862306 C17.3533607,15.5297646 19.5114438,17.6804627 22.1640194,17.6804627 L26.7070921,17.6804627 L26.7070921,21.1976 Z M28.4298686,15.764488 C28.4298686,16.2021764 28.0693082,16.5719697 27.6425598,16.5719697 L22.1640194,16.5719697 C21.8453058,16.5719697 21.5358729,16.5315651 21.2406112,16.4557442 C19.6462094,16.0460452 18.4648293,14.6010138 18.4648293,12.8862306 C18.4648293,11.1714474 19.6462094,9.72641602 21.2406112,9.31671702 C21.5358729,9.24084068 21.8453058,9.20049154 22.1640194,9.20049154 L27.6425598,9.20049154 C28.0840351,9.20049154 28.4298686,9.5253354 28.4298686,9.94002261 L28.4298686,15.764488 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const logout = (
  <svg
    width="84px"
    height="84px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-24">
        <g id="Group-23">
          <circle
            id="Oval"
            fill="#212126"
            cx="12.6"
            cy="12.6"
            r="12.6"
          ></circle>
          <g
            id="noun_on-off_1580793"
            transform="translate(7.500000, 6.900000)"
            fill="#FFFFFF"
            fillRule="nonzero"
          >
            <g id="Group">
              <g id="Shape">
                <path d="M2.62270106,1.46546148 C2.98116656,1.25625508 3.44000959,1.37957825 3.64755562,1.74091148 C3.85510166,2.10224473 3.73275724,2.56475846 3.37429174,2.77396487 C2.22318349,3.44577066 1.5,4.68298624 1.5,6.048 C1.5,8.13563635 3.17893219,9.828 5.25,9.828 C7.32106781,9.828 9,8.13563635 9,6.048 C9,4.68843553 8.28262815,3.45545574 7.13883836,2.78166367 C6.78121744,2.57099372 6.66073474,2.10798368 6.8697327,1.74750179 C7.0787307,1.3870199 7.53806606,1.26557333 7.89568699,1.47624329 C9.49513241,2.41845632 10.5,4.14556818 10.5,6.048 C10.5,8.9706909 8.14949494,11.34 5.25,11.34 C2.35050506,11.34 0,8.9706909 0,6.048 C0,4.13792457 1.01298578,2.40491795 2.62270106,1.46546148 Z M4.5,0.756 C4.5,0.338472729 4.83578644,0 5.25,0 C5.66421356,0 6,0.338472729 6,0.756 L6,3.024 C6,3.44152727 5.66421356,3.78 5.25,3.78 C4.83578644,3.78 4.5,3.44152727 4.5,3.024 L4.5,0.756 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const group = (
  <svg
    width="84px"
    height="84px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        x1="-4.95290311%"
        y1="84.3108291%"
        x2="96.9366126%"
        y2="18.5486491%"
        id="linearGradient-1"
      >
        <stop stopColor="#FFF78F" offset="0%"></stop>
        <stop stopColor="#00ECFF" offset="48.8040253%"></stop>
        <stop stopColor="#008FFF" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-14">
        <g id="Group-20" fill="#212126">
          <circle id="Oval" cx="12.6" cy="12.6" r="12.6"></circle>
        </g>
        <g
          id="Lablaco-Logo-13032018-01"
          transform="translate(6.600000, 7.500000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <path
            d="M11.3390913,6.48725938 L11.2061257,6.35486634 L11.2104498,6.35056087 L9.20083326,4.34959601 L9.65269973,3.89967492 L9.65486174,3.90182765 L9.99430205,3.56061955 C10.3867124,3.16666951 10.6029165,2.64355551 10.6029165,2.08922689 C10.6029165,0.937515001 9.66134785,0 8.50465624,0 C7.34796461,0 6.40639601,0.937515001 6.40639601,2.08922689 C6.40639601,2.64463187 6.62260005,3.16666951 7.01501039,3.56061955 L7.36417992,3.90936222 L7.80847923,4.34959601 L6.0042565,6.14605128 L4.20003376,4.34959601 L4.64325205,3.90828585 L4.6454141,3.91043858 L4.9935026,3.56061955 C5.38591294,3.16666951 5.60211698,2.64355551 5.60211698,2.08922689 C5.60211698,0.937515001 4.66054838,0 3.50385675,0 C2.34716513,0 1.40559652,0.937515001 1.40559652,2.08922689 C1.40559652,2.64463187 1.62180057,3.16666951 2.0142109,3.56061955 L2.36338043,3.90936222 L2.80767973,4.34959601 L1.15479984,5.99536 L0.660773603,6.48725938 C-0.220257868,7.36449788 -0.220257868,8.79175952 0.660773603,9.66792161 C1.10074883,10.1060027 1.68017566,10.3255814 2.25852147,10.3255814 C2.83686728,10.3255814 3.4152131,10.1060027 3.85626934,9.66792161 L5.25835255,8.27187462 L5.25943357,8.27295099 L6.0042565,7.53133465 L6.26262033,7.78858618 L6.26045828,7.79073891 L8.14467651,9.6668453 C8.16197283,9.68406718 8.1814312,9.69913624 8.19872752,9.7152818 L8.24304935,9.75941277 L8.24521139,9.75726005 C8.65924213,10.1232246 9.18461795,10.3255814 9.74242437,10.3255814 C9.79323233,10.3255814 9.84404028,10.3234287 9.89376719,10.3201996 C10.4407634,10.2846795 10.9488429,10.0554135 11.3401722,9.66576889 C12.2201227,8.79175952 12.2201227,7.36449788 11.3390913,6.48725938 Z M7.71334945,2.86851606 L7.6787568,2.83407234 C7.49282133,2.62956275 7.39120542,2.36692938 7.39120542,2.09030325 C7.39120542,1.47892723 7.89063676,0.981646022 8.50465624,0.981646022 C9.11867571,0.981646022 9.61810706,1.47892723 9.61810706,2.09030325 C9.61810706,2.36692938 9.5175722,2.62741001 9.33271776,2.8319196 L8.50465624,3.65641615 L7.71334945,2.86851606 Z M2.71254996,2.86851606 L2.67795731,2.83407234 C2.49202183,2.62956275 2.39040594,2.36692938 2.39040594,2.09030325 C2.39040594,1.47892723 2.88983728,0.981646022 3.50385675,0.981646022 C4.11787623,0.981646022 4.61730757,1.47892723 4.61730757,2.09030325 C4.61730757,2.36692938 4.51677269,2.62848638 4.33191823,2.8319196 L3.50385675,3.65641615 L2.71254996,2.86851606 Z M5.04539157,7.10078814 L5.04431055,7.09971178 L3.16009232,8.97581815 C2.66282303,9.47094665 1.85421991,9.47094665 1.35803163,8.97581815 C0.860762341,8.48068968 0.860762341,7.67556772 1.35803163,7.18151561 L2.84335341,5.70258839 L2.84335341,5.70258839 L3.50493778,5.04385225 L5.3091605,6.84030751 L5.04539157,7.10078814 Z M10.6429142,8.97581815 C10.4018468,9.21584778 10.0818647,9.34716455 9.74134332,9.34716455 C9.42568546,9.34716455 9.12732388,9.23199335 8.89382351,9.02425464 L6.69935249,6.83923114 L8.50357522,5.04277588 L9.1608355,5.69720655 L9.15651142,5.70151202 L10.6418332,7.18043924 C11.1391025,7.67556772 11.1391025,8.48068968 10.6429142,8.97581815 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const cross = (
  <svg
    height="15px"
    width="15px"
    viewBox="0 0 511.992 511.992"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m415.402344 495.421875-159.40625-159.410156-159.40625 159.410156c-22.097656 22.09375-57.921875 22.09375-80.019532 0-22.09375-22.097656-22.09375-57.921875 0-80.019531l159.410157-159.40625-159.410157-159.40625c-22.09375-22.097656-22.09375-57.921875 0-80.019532 22.097657-22.09375 57.921876-22.09375 80.019532 0l159.40625 159.410157 159.40625-159.410157c22.097656-22.09375 57.921875-22.09375 80.019531 0 22.09375 22.097657 22.09375 57.921876 0 80.019532l-159.410156 159.40625 159.410156 159.40625c22.09375 22.097656 22.09375 57.921875 0 80.019531-22.097656 22.09375-57.921875 22.09375-80.019531 0zm0 0"
      fill="#000"
    />
  </svg>
);

export const info = (
  <svg
    height="16px"
    width="16px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="scale(0.03)">
      <path
        d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M280.5,382.5h-51v-153h51V382.5z M280.5,178.5h-51v-51h51V178.5z"
        fill="#212126"
      />
    </g>
  </svg>
);
